import { postStartupAskNewDates, postStartupConfirmMatch } from "api/Api"
import { MediaTablet } from "api/const/MediaQuery"
import clsx from "clsx"
import { LoginType } from "components/types/Context"
import { ModalType } from "components/types/types"
import useMediaQuery from "hook/useMediaQuery"
import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext"
import { Button, DateMeetingCard, Logo } from "../../atoms"
import { MessageCard } from "../../molecules/MessageCard"
import './SelectMeetingMessage.css'

type DateMeeting = {
  date: string
}

type SelectMeetingProps = {
  fromSender: boolean,
  dates: DateMeeting[],
  matchId: string,
  isOld: boolean,
}


export const SelectMeetingMessage = ({ dates, fromSender, isOld, matchId }: SelectMeetingProps) => {

  const { setChatIsOpen, setErrorModal, loginType, setModal, getMessagesList} = useContext(AppGeneralContext)
  const [isDisabled, setIsDisabled] = useState<boolean>(false)
  const tablet = useMediaQuery(MediaTablet)
  const navigate = useNavigate()

  const newAvailability = () => {

    if (isOld) {
      return
    }
    if (isDisabled) {
      return
    }

    postStartupAskNewDates({ matchId: matchId }).then((res) => {
      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return false
      }
      const route = loginType === LoginType.startup ? "start-up" : "corporate"
      return tablet ? navigate(`${route}//profile/messaging`) : setChatIsOpen(false)
    })
  }



  const selectDate = (dateID: number) => {
    if (isOld) {
      return
    }

    postStartupConfirmMatch({ matchId: matchId, selectedDateIndex: dateID }).then((res) => {
      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return false
      }
      setChatIsOpen(false)
      if(!fromSender){
      setModal({isOpen: true,
        type: "success" ,
        title: "Congratulation!",
        message:"Your match has been successfully confirmed. Check your email for the calendar event and video call link."})
      }
      getMessagesList()
    })

  }

  return (
    <MessageCard className="" fromSender={fromSender}>
      <div>
        {fromSender ?
          <p className="p-0m-0">You have sent meeting availability </p>
          :
          <p className="p-0m-0">Do you want have a meeting with us?</p>
        }
      </div>
      <div className="d-flex flex-row justify-content-between">
        {dates.map((x, index) => {
          return <DateMeetingCard disabled={fromSender || isOld || isDisabled}
            date={x.date}
            key={index}
            selectDate={() => { selectDate(index + 1); setIsDisabled(true) }} />
        })}
      </div>
      {!fromSender &&
        <div className={clsx("w-100 pt-4 pb-2 pe-2 tae pointer",
          { "link-disabled": isOld },
          { "link-disabled": isDisabled })} onClick={() => { newAvailability(); setIsDisabled(true) }}>
          <p className="p-0 m-0 tx-underline">Ask for new availability </p>
        </div>
      }
    </MessageCard>
  )
}

